export default "__VITE_ASSET__rQ5KNBcO__"